<template>
    <div class="users">
        <h1>Welcome back {{ this.$route.params.name }}</h1>
    </div>
</template>
